export default "__VITE_ASSET__CfReDAki__"